import React from 'react';

import { Add as AddIcon } from '@mui/icons-material';
import { Grid } from '@mui/material';

import { validateWithYupSchema } from '@hrlogics/react-form-utils/yup';

import { Button, FieldArrayTemplate } from 'src/components/common';
import { Field, Form, TextField } from 'src/components/finalForm';

import { emptyStaffObject, initialValues } from './constants';
import { InviteFormFields, InviteFormFieldsForStaff, InviteFormFieldsValues } from './types';
import { peoPayrollProviderStaffInviteValidationSchema } from './utils';

export type InvitePeoPayrollProviderStaffFormProps = {
  onCloseModal: () => void;
  onSubmit: (formFields: InviteFormFieldsValues) => void;
};

export const InvitePeoPayrollProviderStaffForm: React.FC<
  InvitePeoPayrollProviderStaffFormProps
> = ({ onCloseModal, onSubmit }) => {
  return (
    <Form<InviteFormFieldsValues>
      onSubmit={onSubmit}
      initialValues={initialValues}
      validate={validateWithYupSchema(peoPayrollProviderStaffInviteValidationSchema)}
    >
      {({ dirty, submitting, valid }) => (
        <Grid container spacing={2}>
          <Grid size={12}>
            <FieldArrayTemplate
              label="Invitation"
              name={InviteFormFields.staff}
              onAdd={fields => fields.push(emptyStaffObject)}
              onRemove={(fields, index) => fields.remove(index)}
              addIcon={<AddIcon />}
            >
              {({ renderFieldName }) => (
                <Grid container spacing={2}>
                  <Grid size={12}>
                    <Field
                      name={renderFieldName(InviteFormFieldsForStaff.email)}
                      label="Email Address"
                      required
                      component={TextField}
                      fullWidth
                      disabled={submitting}
                    />
                  </Grid>
                </Grid>
              )}
            </FieldArrayTemplate>
          </Grid>

          <Grid container justifyContent="center" spacing={2} size={12}>
            <Grid>
              <Button onClick={onCloseModal} variant="outlined" color="error">
                Close
              </Button>
            </Grid>
            <Grid>
              <Button
                loading={submitting}
                type="submit"
                disabled={!dirty || submitting || !valid}
                variant="contained"
              >
                Send Invite
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Form>
  );
};
